<h1 mat-dialog-title>Change invoice status</h1>
<mat-dialog-content>
  <glxy-form-field>
    <glxy-label id="change-status">Mark invoice as…</glxy-label>
    <mat-radio-group aria-labelledby="change-status" [(ngModel)]="invoiceStatus">
      <div class="radio-button">
        <mat-radio-button [value]="PaidStatus">
          {{ PaidStatus }}
          <extended>Payment was collected outside of Vendasta Payments.</extended>
        </mat-radio-button>
      </div>
      <div class="radio-button">
        <mat-radio-button [value]="VoidStatus">
          {{ VoidStatus }}
          <extended>This invoice was accidentally finalized or contains a mistake.</extended>
        </mat-radio-button>
      </div>
    </mat-radio-group>
  </glxy-form-field>
  <glxy-form-field>
    <glxy-label>Internal notes (optional)</glxy-label>
    <textarea
      matInput
      #internalNotes
      placeholder="Internal notes (optional)"
      [(ngModel)]="reason"
      maxlength="5000"
    ></textarea>
    <glxy-hint align="end">{{ internalNotes.value?.length || 0 }}/5000</glxy-hint>
  </glxy-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close class="left-action-button">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="(loading$ | async) || !invoiceStatus" (click)="changeStatus()">
    <ng-container *ngIf="(loading$ | async) === false; else loadingSpinner">
      <span>Update status</span>
    </ng-container>
    <ng-template #loadingSpinner>
      <mat-progress-spinner [diameter]="24" mode="indeterminate"></mat-progress-spinner>
    </ng-template>
  </button>
</mat-dialog-actions>
